import { render, staticRenderFns } from "./DepotList.vue?vue&type=template&id=6aee4f88&"
import script from "./DepotList.vue?vue&type=script&lang=js&"
export * from "./DepotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports